const SURFACE_CONDITIONS = [
  {
    name: 'sea_state',
    label: 'Sea State'
  },
  {
    name: 'wind_speed',
    label: 'Wind Speed'
  },
  {
    name: 'visibility',
    label: 'Visibility'
  },
  {
    name: 'current',
    label: 'Current'
  }
]

const SUBSEA_CONDITIONS = [
  {
    name: 'composition',
    label: 'Composition'
  },
  {
    name: 'topology',
    label: 'Topology'
  },
  {
    name: 'current_speed',
    label: 'Current Speed'
  },
  {
    name: 'current_direction',
    label: 'Current Direction'
  },
  {
    name: 'visibility_lights_off',
    label: 'Visibility, Lights Off'
  },
  {
    name: 'visibility_lights_on',
    label: 'Visibility, Lights On'
  }
]

module.exports = {
  SURFACE_CONDITIONS,
  SUBSEA_CONDITIONS
}
